
import { lazy } from "react";
import PartDetils from "../pages/Frontend/shop/PartDetils.jsx";
import PartNumberSearch from "../pages/Frontend/shop/PartNumberSearch.jsx";
import HomePage from "../pages/Frontend/homePage/HomePage";
import Shop from "../pages/Frontend/shop/Shop.js";
import AddtoCart from "../pages/Frontend/shop/AddtoCart.jsx";

// import StripeCheckoutWrapper from "../pages/Frontend/shop/StripeCheckoutWrapper.jsx";
import Signup from "../pages/Frontend/user_auth/signup/AdminSingIn.jsx";
import Login from "../../components/pages/Frontend/user_auth/login/Login";
import MainBlog from "../pages/Frontend/blogPage/MainBlog";
import BookNow from "../pages/Frontend/homePage/components/bookNow/BookNow";
import OurServices from "../pages/Frontend/services/OurServices.jsx";
import Clutch from "../pages/Frontend/services/components/Clutch.jsx";
import Breaks from "../pages/Frontend/services/components/Breaks.jsx";
import Electrical from "../pages/Frontend/services/components/Electrical.jsx";
import EngineDiagnostics from "../pages/Frontend/services/components/EngineDiagnostics.jsx";
import Exhaust from "../pages/Frontend/services/components/Exhaust.jsx";
import Maintenance from "../pages/Frontend/services/components/Maintenance.jsx";
import Radiators from "../pages/Frontend/services/components/Radiators.jsx";
import Suspension_Steering from "../pages/Frontend/services/components/Suspension_Steering.jsx";
import TransferCase from "../pages/Frontend/services/components/TransferCase.jsx";
import Fuel from "../pages/Frontend/services/components/Fuel.jsx";
import ContactUs from "../pages/Frontend/contactus/ContactUs.jsx";
import About from "../pages/Frontend/aboutus/About.jsx";
import SingleBlogPage from "../pages/Frontend/blogPage/SingleBlogPage.jsx";
import Cart from "../pages/Frontend/shop/Cart.jsx";
import OtpPage from "../pages/Frontend/user_auth/login/OtpPage.jsx";
import CheckoutPage from "../pages/Frontend/shop/CheckoutPage.jsx";
import OrderCancel from "../pages/Frontend/homePage/Policy/Ordercancel.jsx";
import PrivacyPolicy from "../pages/Frontend/homePage/Policy/PrivacyPolicy.jsx";
const StripeCheckoutWrapper=lazy(() => import("../pages/Frontend/shop/StripeCheckoutWrapper.jsx"));
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/", exact: true, name: "HomePage" },
  { path: "/homepage", element: HomePage },
  
  { path: "/login", element: Login },
  { path: "/blog/:categoryName?", element: MainBlog },
  { path: "/blog/single-blog/:id", element: SingleBlogPage },
  { path: "/book-now", element: BookNow },
  { path: "/shop", element: Shop },
  { path: "/shop/parts", element: PartDetils },
  { path: "/shop/vehicles/:makes?/:model?/:year?/:category?", element: Shop },
  { path: "/our-services", element: OurServices },
  { path: "/clutch", element: Clutch },
  { path: "/breaks", element: Breaks },
  { path: "/electrical", element: Electrical },
  { path: "/engine", element: EngineDiagnostics },
  { path: "/exhaust", element: Exhaust },
  { path: "/maintenance", element: Maintenance },
  { path: "/radiators", element: Radiators },
  { path: "/suspension", element: Suspension_Steering },
  { path: "/transfer", element: TransferCase },
  { path: "/fuel", element: Fuel },
  { path: "/contact-us", element: ContactUs },
  { path: "/about-us", element: About },
  { path: "/order-cancel", element: OrderCancel },
  { path: "/privacy-policy", element: PrivacyPolicy },
  { path: "/shop/single-product/:id", element: AddtoCart }, 
  { path: "/addtocart", element: Cart },
  { path: "/part-number-search", element: PartNumberSearch },
  { path: "/singup-otp/:email", element: OtpPage },
  {
    path: "/shop/checkouts",
    element: StripeCheckoutWrapper,
  },
  { path: "/partdetails", element: PartDetils },
];

export default routes;